import React, { useState } from 'react';

function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    freightType: 'Select Option',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent routing and page reload

    const { name, email, phone, message, freightType } = formData;
    const subject = encodeURIComponent('New Message from Contact Page');
    const body = encodeURIComponent(`
      Name: ${name}
      Email: ${email}
      Phone: ${phone}
      Service: ${freightType}
      Message: ${message}
    `);

    // Construct the mailto link
    const mailtoLink = `mailto:contact@titatechnologies.com?subject=${subject}&body=${body}`;

    // Open the email client with the pre-filled data
    window.location.href = mailtoLink; // This triggers the email client without routing
  };

  return (
    <>
      <div id="searchbox-overlay" />
      <div className="map-wrapper" style={{
        position: 'relative',
        height: '400px',
        overflow: 'hidden',
        background: '#0f0f0f',
        borderRadius: '12px',
        margin: '20px 0'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at center, rgba(255, 0, 30, 0.08) 0%, transparent 70%)',
          zIndex: 1
        }} />
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          textAlign: 'center',
          position: 'relative',
          zIndex: 2,
          padding: '40px'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            background: 'rgba(255, 0, 30, 0.1)',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '24px',
            border: '1px solid rgba(255, 0, 30, 0.2)',
            boxShadow: '0 0 20px rgba(255, 0, 30, 0.1)'
          }}>
            <i className="fa-light fa-map-location-dot" style={{ fontSize: '32px', color: '#FF001E' }} />
          </div>
          <h2 style={{
            color: '#fff',
            fontSize: '28px',
            fontWeight: '700',
            marginBottom: '12px'
          }}>
            Map <span style={{ color: '#FF001E' }}>Coming Soon</span>
          </h2>
          <p style={{
            color: '#a0a0a0',
            maxWidth: '450px',
            fontSize: '16px',
            lineHeight: '1.5'
          }}>
            We are currently updating our interactive location map. <br />
            Our physical office is located at: <br />
            <strong>No 81, Rajaram Street, Jawahar Nagar, Thirumangalam - 625706</strong>
          </p>
        </div>
      </div>
      <section className="contact-section padding">
        <div className="map-pattern" />
        <div className="container">
          <div className="row">
            <div className="col-lg-7 sm-padding">
              <div className="contact-form-wrap row-gap">
                <div className="section-heading mb-40">
                  <h2
                    className="text-anim"
                    data-effect="fade-in-right"
                    data-split="char"
                    data-delay="0.3"
                    data-duration={1}
                  >
                    Book a <span className="hl">Consultation</span>
                  </h2>
                  <p
                    className="text-anim"
                    data-effect="fade-in-bottom"
                    data-ease="power4.out"
                  >
                    Our commitment to excellence guarantees top-tier outcomes with every project. <br />
                    Our expert team utilizes innovative strategies and industry best practices to deliver superior solutions tailored to your needs.
                  </p>
                </div>
                <div className="contact-form">
                  <form onSubmit={handleSubmit} className="form-horizontal">
                    <div className="contact-form-group">
                      <div className="form-field">
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Your Name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="form-field">
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Your Email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="form-field">
                        <input
                          type="phone"
                          name="phone"
                          className="form-control"
                          placeholder="Your Phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="form-field">
                        <select
                          name="freightType"
                          className="form-control"
                          value={formData.freightType}
                          onChange={handleChange}
                          required
                        >
                          <option value="Select Option">Select Option</option>
                          <option value="iTrain (LMS)">iTrain (LMS)</option>
                          <option value="IT Projects">IT Projects</option>
                          <option value="IT Careers">IT Careers</option>
                          <option value="IT Staffing">IT Staffing</option>
                        </select>
                      </div>
                      <div className="form-field message">
                        <textarea
                          name="message"
                          className="form-control"
                          placeholder="Message"
                          value={formData.message}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="form-field submit-btn">
                        <button type="submit" className="default-btn" onClick={handleSubmit}>
                          Send Message
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-5 sm-padding">
              <div className="section-heading mb-40">
                <h2
                  className="text-anim"
                  data-effect="fade-in-right"
                  data-split="char"
                  data-delay="0.3"
                  data-duration={1}
                >
                  We Ensure You Will Always
                  <br />
                  <span className="hl">Get the Best Result</span>
                </h2>
              </div>
              <ul className="contact-info-list">
                <li className="wow fade-in-bottom" data-wow-delay="300ms">
                  <i className="fa-light fa-envelope-open-text" />
                  <h3>
                    Write us email <span>contact@titatechnologies.com</span>
                  </h3>
                </li>
                <li className="wow fade-in-bottom" data-wow-delay="300ms">
                  <i className="fa-light fa-clock" />
                  <h3>
                    Office Time
                    <span>Mon-Sat 9.30am-6pm, Sunday Closed</span>
                  </h3>
                </li>
                <li className="wow fade-in-bottom" data-wow-delay="500ms">
                  <i className="fa-light fa-location-dot" />
                  <h3>
                    Headquarters: <span>No 81,Rajaram street, jawahar nagar,Thirumangalam-625706</span>
                  </h3>
                </li>
                <li className="wow fade-in-bottom" data-wow-delay="500ms">
                  <i className="fa-light fa-location-dot" />
                  <h3>
                    Regional Office: <span>Toronto, Canada</span>
                  </h3>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactPage;
